import { toast } from 'react-toastify'
import { getAllSchoolMembers } from '../../../api/admin/incidents'
import { getAllIncidents } from '../../../api/candidate/incidents'
import {
  incidentResponseStaff,
  incidentStaffObj,
  schoolMembers,
  schoolMembersResponse,
} from '../../../utils/types'

export const getAllCandidates = async (): Promise<schoolMembers[]> => {
  const response = (await getAllSchoolMembers()) as schoolMembersResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getIncidents = async (
  sortBy: string,
  sortOrderValue: string
): Promise<incidentStaffObj> => {
  const response = (await getAllIncidents(
    sortBy,
    sortOrderValue
  )) as incidentResponseStaff
  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const initialData = {
  candidate: '',
  employer: '',
  severity_level: '',
  overview: '',
  status: 'open',
}

export const calculatePageCount = (dataLength: number): number => {
  if (dataLength < 4) {
    return 1
  } else {
    return Math.ceil(dataLength / 4)
  }
}
